import React, { PureComponent } from 'react';
import MainLayout from '../layout/Main';
import Restaurant from '../layout/Restaurant';
import RestaurantGroupLayout from '../layout/RestaurantGroup';
import AuthLayout from '../layout/Auth';
import {
    AUTH_COMP_MAIN,
    AUTH_COMPAMY_EMPLOYE_RESTAURANT_R_GROUP_MAIN,
    AUTH_COMPAMY_RESTAURANT_EMPLOYE_R_GROUP_MAIN,
    AUTH_COMPANY_RESTAURANT_R_GROUP_MAIN,
    AUTH_MAIN,
    AUTH_RESTAURANT_R_GROUP_MAIN
} from '../utils';
import CompanyLayout from '../layout/Company';
import PropTypes from 'prop-types';
import EmployeesLayout from '../layout/Employees';

export default class Wrapper extends PureComponent {
    static propTypes = {
        mode: PropTypes.string,
        hideSideMenu: PropTypes.bool
    };

    render() {
        const {
            children,
            mode,
            hideSideMenu
        } = this.props;

        const data = {
            [AUTH_COMPANY_RESTAURANT_R_GROUP_MAIN]: <AuthLayout>
                <CompanyLayout>
                    <Restaurant>
                        <RestaurantGroupLayout>
                            <MainLayout>
                                {children}
                            </MainLayout>
                        </RestaurantGroupLayout>
                    </Restaurant>
                </CompanyLayout>
            </AuthLayout>,
            [AUTH_MAIN]: <AuthLayout>
                <MainLayout hideSideMenu={hideSideMenu}>
                    {children}
                </MainLayout>
            </AuthLayout>,
            [AUTH_COMP_MAIN]: <AuthLayout>
                <CompanyLayout>
                    <MainLayout>
                        {children}
                    </MainLayout>
                </CompanyLayout>
            </AuthLayout>,
            [AUTH_RESTAURANT_R_GROUP_MAIN]: <AuthLayout>
                <Restaurant>
                    <RestaurantGroupLayout>
                        <MainLayout>
                            {children}
                        </MainLayout>
                    </RestaurantGroupLayout>
                </Restaurant>
            </AuthLayout>,
            [AUTH_COMPAMY_RESTAURANT_EMPLOYE_R_GROUP_MAIN]: <AuthLayout>
                <CompanyLayout>
                    <Restaurant>
                        <EmployeesLayout>
                            <RestaurantGroupLayout>
                                <MainLayout>
                                    {children}
                                </MainLayout>
                            </RestaurantGroupLayout>
                        </EmployeesLayout>
                    </Restaurant>
                </CompanyLayout>
            </AuthLayout>,
            [AUTH_COMPAMY_EMPLOYE_RESTAURANT_R_GROUP_MAIN]: <AuthLayout>
                <CompanyLayout>
                    <EmployeesLayout>
                        <Restaurant>
                            <RestaurantGroupLayout>
                                <MainLayout>
                                    {children}
                                </MainLayout>
                            </RestaurantGroupLayout>
                        </Restaurant>
                    </EmployeesLayout>
                </CompanyLayout>
            </AuthLayout>
        };

        return data[mode];
    }
}
